export default {
  goals: {},
  loadingGoals: false
}
